import { createApp } from 'vue'
import PickUpAddress from './PickUpAddress'

const el = '.kb-component--pick-up-address'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((PickUpAddressDOM) => {
            const component = createApp(PickUpAddress).use(Store)
            component.mount(PickUpAddressDOM)
        })
    }
}
